


















































import { Vue, Component, Prop } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useBeneficiaryStore } from "@/employer/store/beneficiary";
import { BeneficiaryStatus, Beneficiary, BeneficiaryRelationshipType, BeneficiaryState, FetchState } from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { lastFour as ssnLastFour } from "@/shared/ssn";
import _, { map } from "lodash";

interface BeneficiaryTableItem {
  id: number;
  name: string;
  dateOfBirth: string;
  ssn: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  relationship: BeneficiaryRelationshipType;
  share: number;
  status: BeneficiaryStatus;
}

@Component({
    components: {
        GenericLoadingSpinner
    }
})

export default class AccountHolderBeneficiaries extends Vue {
    beneficiaryStore = useBeneficiaryStore();
    beneficiaryStatus = BeneficiaryStatus;

    @Prop({ required: true })
        username: string;

    @Prop({ required: true })
        partnerId: number;

    get isLoaded () {
        return this.beneficiaryStore.isBeneficiariesLoaded;
    }

    get beneficiaries (): BeneficiaryTableItem[] {
      return this.sortAndMapBeneficiaries();
    }

    mounted () {
      this.beneficiaryStore.fetchState = FetchState.Uninitialized;
      this.beneficiaryStore.loadBeneficiaries({
          username: this.username,
          partnerId: this.partnerId
      });
    }

    sortAndMapBeneficiaries (): BeneficiaryTableItem[] {
      const beneficiaries = Object.values(this.beneficiaryStore.beneficiaries);
      const sorted = _.sortBy(beneficiaries, option => option.status, option => option.lastName);
      const mappedBeneficiaries = sorted.map(item => this.mapBeneficiaryForDisplay(item));
      return mappedBeneficiaries;
    }

    mapBeneficiaryForDisplay (unmappedBeneficiary: Beneficiary): BeneficiaryTableItem {
      const beneficiaryToDisplay: BeneficiaryTableItem = {
          id: unmappedBeneficiary.id,
          name: this.fullName(unmappedBeneficiary),
          dateOfBirth: formatMMddyyyyDateString(unmappedBeneficiary.dateOfBirth),
          ssn: ssnLastFour(unmappedBeneficiary.ssn),
          relationship: unmappedBeneficiary.relationshipType,
          address1: unmappedBeneficiary.address1,
          address2: unmappedBeneficiary.address2,
          city: unmappedBeneficiary.city,
          state: unmappedBeneficiary.stateCode,
          zip: unmappedBeneficiary.zip,
          share: unmappedBeneficiary.share,
          status: unmappedBeneficiary.status
      };
      return beneficiaryToDisplay;
    }

    fullName (beneficiary: Beneficiary) {
      if (this.isEstateBeneficiary(beneficiary)) {
        return beneficiary.estateName;
      }
      return `${beneficiary.firstName} ${this.middleInitial(beneficiary)} ${beneficiary.lastName}`;
    }

    middleInitial (beneficiary: Beneficiary) {
      if (beneficiary.middleInitial) {
        return beneficiary.middleInitial;
      }
      return "";
    }

    isEstateBeneficiary (beneficiary: Beneficiary): boolean {
      return beneficiary.relationshipType === BeneficiaryRelationshipType.Estate;
    }
}
